import { Instagram, Facebook, Youtube, MessageCircle, MapPin } from "lucide-react";
import { LOCALITIES, NAV_LINKS, SOCIALS, WA_DEFAULT, WHATSAPP_DISPLAY } from "../data/site";
import { scrollToHash } from "../lib/motion";
import LogoMark from "./LogoMark";

export const Footer = () => (
  <footer className="bg-navy pb-28 pt-20 text-white sm:pb-14">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/shivaay-logo.png"
              alt="Shivaay Consultant logo"
              className="h-11 w-11 rounded-xl object-cover ring-1 ring-gold/40"
            />
            <span className="leading-none">
              <span className="font-serif text-2xl font-semibold tracking-wide text-gold-light">Shivaay</span>
              <span className="mt-0.5 block text-[9px] font-semibold uppercase tracking-[0.4em] text-white/60">
                Consultant
              </span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
            Real estate advisory for new projects and resale flats across
            Mumbai&apos;s western suburbs — Borivali to Andheri, East &amp; West —
            tracked on Housing.com &amp; 99acres.
          </p>
          <div className="mt-6 flex gap-3">
            {[
              { icon: Instagram, href: SOCIALS.instagram, testid: "footer-instagram-link", label: "Instagram" },
              { icon: Facebook, href: SOCIALS.facebook, testid: "footer-facebook-link", label: "Facebook" },
              { icon: Youtube, href: SOCIALS.youtube, testid: "footer-youtube-link", label: "YouTube" },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                data-testid={s.testid}
                aria-label={s.label}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-all hover:border-gold hover:text-gold-light"
              >
                <s.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.3em] text-gold-light">Explore</h4>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.href.slice(1)}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToHash(l.href);
                  }}
                  className="text-sm text-white/70 transition-colors hover:text-gold-light"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.3em] text-gold-light">Localities</h4>
          <p className="mt-5 flex flex-wrap gap-x-2 gap-y-1.5 text-sm leading-relaxed text-white/70">
            {LOCALITIES.map((loc) => (
              <span key={loc} className="flex items-center gap-1.5">
                <MapPin className="h-3 w-3 shrink-0 text-gold" />
                {loc}
              </span>
            ))}
          </p>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.3em] text-gold-light">Talk To Us</h4>
          <a
            href={WA_DEFAULT}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-whatsapp-cta"
            className="mt-5 flex items-center gap-3 rounded-2xl border border-wa/40 bg-wa/15 p-4 transition-colors hover:border-wa"
          >
            <MessageCircle className="h-6 w-6 text-[#4ADE80]" />
            <span>
              <span className="block text-sm font-bold text-white">{WHATSAPP_DISPLAY}</span>
              <span className="text-xs text-white/60">
                Mobile &amp; WhatsApp Business — replies within the hour
              </span>
            </span>
          </a>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-8">
        <p className="text-xs leading-relaxed text-white/45">
          © {new Date().getFullYear()} Shivaay Consultant. All rights reserved.
          Listing details are sourced from public Housing.com and 99acres
          listings and change frequently — confirm current availability and
          pricing with us before deciding. This site is not affiliated with
          Housing.com or 99acres; all trademarks belong to their respective
          owners.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
